import { render } from "./KeyProcessPanel.vue?vue&type=template&id=b79a09da&scoped=true"
import script from "./KeyProcessPanel.vue?vue&type=script&lang=js"
export * from "./KeyProcessPanel.vue?vue&type=script&lang=js"

import "./KeyProcessPanel.vue?vue&type=style&index=0&id=b79a09da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b79a09da"]])

export default __exports__